export default __webpack_public_path__ + "static/media/solutions-HD.b9fbec37.jpg";